var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lab-sim',{attrs:{"script-src":"/simulations/buffers-b/stemble-buffers-b.js","styles-src":"/simulations/buffers-b/styles.css"}},[_c('stemble-buffers-b',_vm._g(_vm._b({},'stemble-buffers-b',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }